import { metricKeys } from '@pulse/metrics';

export const TECH_ERROR_METRICS = [
  metricKeys.VideoStartFailuresTech,
  metricKeys.VideoStartFailuresTechPercentage,
  metricKeys.VideoPlaybackFailuresTech,
  metricKeys.VideoPlaybackFailuresTechPercentage,
  metricKeys.VideoPlaybackFailuresTechPer1000PlayingMinutes,
];

export const ERROR_METRICS = [
  metricKeys.VideoPlaybackFailures,
  metricKeys.VideoPlaybackFailuresPercentage,
  metricKeys.VideoStartFailures,
  metricKeys.VideoStartFailuresPercentage,
];
